<template>
  <div :class="selector ? 'edit-wrapper': ''">
    <div :class="selector ? 'edit-form':''">
    <div v-if="selector"><el-button type="primary" plain @click="$emit('close-address-book')" style="width: 100%;">返回并输入新收件人</el-button></div>
    <div v-if="selector" style="font-size: 130%; font-weight: 700; margin-top: 16px;"> 选择一个收件人 </div>
    <div v-if="selector" style="font-size: 90%; font-weight: 300; margin-bottom: 16px;"> 提示：您可以在选择收件人之后对其进行编辑 </div>
    <div v-if="!selector" style="font-size: 90%; font-weight: 300;">
      <el-button @click="editAddress('add')" style="width: 100%; margin: 16px 0;" type="primary">添加新收件人</el-button>
    </div>
    <el-input v-model="addressQuery" placeholder="检索" style="margin: 12px 0">
      <el-button slot="append" icon="el-icon-search" @click="doSearch"></el-button>
    </el-input>
    <el-table :data="displayedAddress" style="padding-bottom: 20px;">
      <el-table-column
        prop="alias"
        label="别名"
        align="center">
      </el-table-column>
      <el-table-column
        prop="name"
        label="姓名"
        align="center">
      </el-table-column>
      <el-table-column
        label="地址"
        align="center">
        <template slot-scope="scope">
          <div>{{ scope.row.province + ' ' + scope.row.city + ' ' + scope.row.district }}</div>
          <div>{{ scope.row.addressInfo }}</div>
          <div>{{ scope.row.postal }}</div>
        </template>
      </el-table-column>
      <el-table-column
        prop="phone"
        label="联系方式."
        align="center">
      </el-table-column>
      <el-table-column
        prop="ID"
        label="身份证号码"
        align="center">
      </el-table-column>
      <el-table-column
        label="操作"
        fixed="right">
        <template slot-scope="scope">
          <div v-if="!selector">
            <el-tooltip content="编辑" placement="bottom" effect="light">
              <i class="material-icons"  @click="editAddress('edit', scope.row)" style="cursor: pointer;">edit</i>
            </el-tooltip>
            <el-tooltip content="复制" placement="bottom" effect="light">
              <i class="material-icons"  @click="editAddress('copy', scope.row)" style="cursor: pointer;">file_copy</i>
            </el-tooltip>
            <el-tooltip content="删除" placement="bottom" effect="light">
              <i class="material-icons"  @click="deleteAddress(scope.row)" style="cursor: pointer;">delete_forever</i>
            </el-tooltip>
          </div>
          <div v-if="selector">
            <el-tooltip content="使用该地址" placement="bottom" effect="light">
              <el-button @click="selectAddress(scope.row)">选择</el-button>
            </el-tooltip>
          </div>
        </template>
      </el-table-column>
      <template slot="empty">
        <half-circle-spinner
          v-if="!loadingBarTimeout"
          :animation-duration="1200"
          :size="48"
          color="#ff1d5e"
          style="margin:32px auto;"
        />
        <div v-if="loadingBarTimeout" style="z-index: 999; background-color: #ffffff; position: absolute; top: 20px; padding-bottom: 20px; left: 0">
          无法找到任何地址/收件人. 您可以 <a href="#" @click="linkAddress()"> 刷新 </a> 或者 <a href="#" @click="editAddress('add')"> 添加新收件人</a>
        </div>
      </template>
    </el-table>
    <div style="overflow: auto; margin-top: 2rem">
      <el-pagination
        background
        layout="prev, pager, next"
        :current-page.sync="currentPage"
        :total="resultAddress.length"
        :page-size="addressPerPage">
      </el-pagination>
    </div>
    <address-editor
      v-if="showAddressEditor"
      :address="editingAddress"
      v-on:close-address-editor="closeAddressEditor">
    </address-editor>
    </div>
  </div>
</template>

<script>
import { db } from '../main'
import { HalfCircleSpinner } from 'epic-spinners'
import { searchAddress, deleteAddress } from '../../public/js/addressBook'
import AddressEditor from '@/components/AddressEditor'

export default {
  name: 'AddressBook',
  props: ['user', 'selector'],
  data () {
    return {
      addressQuery: '',
      allAddress: [],
      searchedAddress: [],
      currentPage: 1,
      addressPerPage: 20,
      showAddressEditor: false,
      editingAddress: null,
      loadingBarTimeout: false
    }
  },
  timers: {
    linkAddress: {
      time: 1000,
      autostart: true,
      repeat: false
    },
    killLoadingBar: {
      time: 10000,
      autostart: false,
      repeat: false
    }
  },
  methods: {
    linkAddress: function () {
      this.$timer.stop('killLoadingBar')
      this.$timer.start('killLoadingBar')
      this.loadingBarTimeout = false
      // console.log('link address book')
      let user = this.user
      if (!user) {
        // console.log('user not ready for loading the address book')
        return
      }
      let uid = user.uid
      this.$bind('allAddress', db.collection('addressBook').where('owner', '==', uid).orderBy('alias'))
    },
    doSearch: function () {
      this.searchedAddress = searchAddress(this.allAddress, this.addressQuery)
    },
    editAddress: function (action, address) {
      // console.log(action, address)
      let addressData = address
      if (action === 'add') {
        addressData = {
          docId: '',
          alias: '新建收件地址',
          name: '',
          phone: '',
          ID: '',
          addressInfo: '',
          district: '',
          city: '',
          province: '',
          postal: '',
          country: '中国',
          owner: this.user.uid
        }
      } else if (action === 'copy') {
        addressData.docId = ''
        addressData.alias = addressData.alias + '_副本'
      }
      this.editingAddress = JSON.parse(JSON.stringify(addressData))
      this.showAddressEditor = true
    },
    deleteAddress: function (address) {
      let that = this
      that.$confirm('这个收件地址将会被永久删除', '注意!', {
        type: 'warning',
        confirmButtonText: '删除',
        cancelButtonText: '取消'
      })
        .then(() => {
          return deleteAddress(address).then(() => {
            that.$message('已删除')
          })
        })
        .catch(() => {
          // console.log('Delete canceled')
        })
    },
    selectAddress: function (address) {
      this.$emit('select-address', address)
    },
    closeAddressEditor: function () {
      this.showAddressEditor = false
      this.linkAddress()
    },
    killLoadingBar: function () {
      this.loadingBarTimeout = true
    }
  },
  watch: {
    user: function () {
      // console.log('user changed, bind address')
      this.linkAddress()
    }
  },
  computed: {
    resultAddress: function () {
      let resultAddress = []
      let useQuery = this.addressQuery !== ''
      if (!useQuery) {
        resultAddress = this.allAddress
      } else {
        resultAddress = this.searchedAddress
      }
      return resultAddress
    },
    displayedAddress: function () {
      let start = this.addressPerPage * (this.currentPage - 1)
      let end = this.addressPerPage * this.currentPage
      return this.resultAddress.slice(start, end)
    },
    existsAlias: function () {
      return null
    }
  },
  components: {
    AddressEditor,
    HalfCircleSpinner
  }
}
</script>

<style>

</style>
